(function($) { //Удаляет классы по регулярке
    $.fn.removeClassWild = function(mask) {
        return this.removeClass(function(index, cls) {
            var re = mask.replace(/\*/g, '\\S+');
            return (cls.match(new RegExp('\\b' + re + '', 'g')) || []).join(' ');
        });
    };
})(jQuery);

(function ($) {  //определяет загружена ли картинка в браузер
    $.fn.bindImageLoad = function (callback) {
        function isImageLoaded(img) {
            // Во время события load IE и другие браузеры правильно
            // определяют состояние картинки через атрибут complete.
            // Исключение составляют Gecko-based браузеры.
            if (!img.complete) {
                return false;
            }
            // Тем не менее, у них есть два очень полезных свойства: naturalWidth и naturalHeight.
            // Они дают истинный размер изображения. Если какртинка еще не загрузилась,
            // то они должны быть равны нулю.
            if (typeof img.naturalWidth !== "undefined" && img.naturalWidth === 0) {
                return false;
            }
            // Картинка загружена.
            return true;
        }

        return this.each(function () {
            var ele = $(this);
            if (ele.is("img") && $.isFunction(callback)) {
                ele.one("load", callback);
                if (isImageLoaded(this)) {
                    ele.trigger("load");
                }
            }
        });
    };
})(jQuery);

$(document).ready(initialize);

function initialize(){
    try {
        proj.menu.projectsCounterInit();  //проставляет атрибуты data-projectid  объектам
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.menu.menuToggleMenu() ;  // действия при кнопке нажатие кнопки меню
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.menu.menuToggleContact();  //действия при кнопке нажатие кнопки контакты
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.menu.fixedMenuScrolledToggle(); //показ меню при скроле вниз
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.menu.showHidenProjectContentToggle(); //разворачивание сворачиваний скрытых объектов у регионов на блоке с картой, видны на мобильном разрешении
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.menu.showFullImageSliderInit(); // судя по коду не делает нихуя
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.menu.openProjectShow(); // штука октрывающая объекты при нажатии на объект, так же управляет анимциями и переключениями при нажатии на кнопки следующий предыдущий объект, так же обрабатывает отрытие обекта при нажатие в меню на "Объекты"
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.contentSwitcher.Init(); //переключалка беграундов при нажатии на преимужества
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.textSlider.sliderInit(); //текстовый слайдер появляющийся при нажатии на какое нибудь преимущество
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.scroll.wowAnimateScrollInit(); //включение анимаций блоков при скролинге вниз, используется для анимирования карты и точек на карте
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.scroll.scrollToBottomInit(); // тоже хуй знает че делает, забыл не помню, но лучше не удалять
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.map.mapDescriptionFadeInit(); // выводит описание области региона при клике на точку на карте
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.map.mapGradientAnimateInit(); // делает анимированным градиент на карте
    } catch (err) {
      // обработка ошибки    
    }

    try {
        proj.forms.sendAjaxForm('.ajax-form'); // отправляет форму аяксом
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.forms.removeLabelsAddPlaceholders('.ajax-form'); // удаляет стандартные лейблы которые делает CMS Flexites и заменяет их плейсхолдорами в input
    } catch (err) {
      // обработка ошибки
    }

    try {
        $("[data-fancybox]").fancybox({ // включение фенсибокса где надо
            buttons : [      
                        'close'
                         ]
        });
    } catch (err) {
      // обработка ошибки
    }

    try {
        proj.forms.maskedInputInit(); // включение маски ввода, используется в форме отправки у поля телефон
    } catch (err) {
      // обработка ошибки
    }
}